<template>
    <div>
      <a-input :disabled="true" v-model="data[keyStr]" placeholder="暂无内容" v-if="data.formType=='1'" />
      <a-checkbox-group   :disabled="true"  v-model="checkedData" v-else>
        <a-checkbox class="row-block" :style="index===0?{marginLeft:'8px'}:{}" :value="dictItem.value" v-for="(dictItem,index) in dictItemData" :key="index">
          {{dictItem.text}}
        </a-checkbox>
      </a-checkbox-group>
    </div>
</template>

<script>
  export default {
    name: 'VoiceItemInput',
    props:{
      data:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      keyStr:{
        type:String,
        default:''
      },
    },
    data(){
      return {
        dictItemData:[],
        checkedData:[]
      }
    },
    watch:{
      data(){
        this.init()
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      init(){
        if(this.data.formType=='2' && this.data.dictJson){
          this.dictItemData = JSON.parse(this.data.dictJson)
          if(this.data[this.keyStr]){
            this.checkedData = this.data[this.keyStr].split(',')
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .row-block{
    display: block;
    line-height: 30px;
    float: left;
  }
</style>